import React, { useEffect, useRef } from 'react';

import Chart from 'chart.js';

import { ViewResponse } from '@/api/gen-protos/ads_pb';

interface LeadsChartProps {
  viewsData: ViewResponse[];
}

const LeadsChart: React.FC<LeadsChartProps> = ({ viewsData }) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstance = useRef<Chart | null>(null);

  useEffect(() => {
    if (viewsData && viewsData.length > 0 && chartRef.current) {
      const dayCounts: { [day: string]: number } = {};

      viewsData.forEach((view) => {
        if (view.getType() === 0) return;
        const timestamp = view.getDate()?.getSeconds() || 0;
        const date = new Date(timestamp * 1000);
        const day = date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        });

        if (dayCounts[day] === undefined) {
          dayCounts[day] = 1;
        } else {
          dayCounts[day]++;
        }
      });

      const labels: string[] = Object.keys(dayCounts);
      const counts: number[] = Object.values(dayCounts);

      const chartData = {
        labels,
        datasets: [
          {
            label: 'leads',
            data: counts,
            borderColor: 'green',
          },
        ],
      };

      const ctx = chartRef.current.getContext('2d');
      if (ctx) {
        if (chartInstance.current) {
          chartInstance.current.destroy();
        }
        chartInstance.current = new Chart(ctx, {
          type: 'line',
          data: chartData,
          options: {
            scales: {
              // @ts-ignore

              x: {
                type: 'time',
                time: {
                  unit: 'day',
                },
              },
              y: {
                beginAtZero: true,
              },
            },
          },
        });
      }
    }
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [viewsData]);

  return (
    <div>
      <canvas ref={chartRef}></canvas>
    </div>
  );
};

export default LeadsChart;
